import classNames from 'classnames';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { useHideGetItBy, useHideShipping, useShippingCost } from '../hooks';

type OwnProps = {
  getItBy: string;
};

export default function Shipping({ getItBy }: OwnProps) {
  const shippingCost = useShippingCost();
  const hideShipping = useHideShipping();
  const hideDot = useHideGetItBy(getItBy);
  const costText =
    shippingCost > 0 ? `$${formatAndDropDecimal(shippingCost)}` : '';
  const divider = ' • ';
  const shippingText = shippingCost ? `Shipping: ` : 'Free Shipping';

  return (
    <div
      data-qa="shipping-cost"
      className={classNames(
        'font-bold items-center leading-4 mr-4 mt-3 text-xs',
        { hidden: hideShipping }
      )}
    >
      {shippingText}
      <span className="font-normal">{costText}</span>
      {hideDot ? null : divider}
    </div>
  );
}
